import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import styles from "./GroupSelector.module.scss";

const GroupSelector = ({ selected, options, onChange }) => {
  const handleChange = option => {
    const selected = options.find(o => o.id === option.value);
    onChange(selected);
  };

  const selectOptions = options.map(o => ({
    value: o.id,
    label: o.name
  }));

  const defaultValue = selectOptions.filter(o => o.value === selected.id);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: 0,
      boxShadow: "none",
      cursor: "pointer"
    }),
    container: provided => ({
      ...provided
    }),
    menu: provided => ({
      ...provided,
      width: 200,
      // minWidth: 200,
      marginLeft: 8,
      marginTop: -8
    }),
    option: (provided, state) => {
      const baseStyle = {
        ...provided,
        fontSize: "18px",
        fontWeight: 500
        // display: "inline"
      };

      if (!state.isSelected && !state.isFocused)
        return {
          ...baseStyle
        };

      if (state.isSelected)
        return {
          ...baseStyle,
          background: "#86A1F3"
        };

      return baseStyle;
    },
    input: () => ({}),
    indicatorsContainer: () => ({}),
    dropdownIndicator: provided => ({
      ...provided,
      padding: 0
    }),
    indicatorSeparator: () => ({}),
    singleValue: () => ({
      background: "linear-gradient(to right, #4fd1e2 0%, #9c8efa 100%)",
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent"
    })
  };

  return (
    <div className={styles.container}>
      <Select
        options={selectOptions}
        styles={customStyles}
        isSearchable={false}
        defaultValue={defaultValue}
        onChange={handleChange}
      />
    </div>
  );
};

GroupSelector.propTypes = {
  selected: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default GroupSelector;
